module.exports = __webpack_public_path__ + "static/media/good-react.9b4fb626.png";